export enum HttpRequestEnum {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
}
